import { getStarterChipGroup, StarterChipGroup } from "./starterChips";

import { useTranslate } from "@/common/hooks/useTranslate";
import { useChatWidgetRoute } from "@/components/ChatWidgetVisibilityManager/helpers/useChatWidgetRoute";

export const useStarterChips = (): string[] => {
  const { t } = useTranslate();
  const { pathWithoutLocale } = useChatWidgetRoute();
  const chips: Record<StarterChipGroup, [string, string, string]> = {
    bank: [
      t("dashboard", "organizationAssistant.chips.bank.lastPayout"),
      t("dashboard", "organizationAssistant.chips.bank.failedPayout"),
      t("dashboard", "organizationAssistant.chips.bank.verification"),
    ],
    forms: [
      t("dashboard", "organizationAssistant.chips.forms.soldOut"),
      t("dashboard", "organizationAssistant.chips.forms.closeSales"),
      t("dashboard", "organizationAssistant.chips.forms.guestQuestion"),
    ],
    payments: [
      t("dashboard", "organizationAssistant.chips.payments.confirmation"),
      t("dashboard", "organizationAssistant.chips.payments.findByEmail"),
      t("dashboard", "organizationAssistant.chips.payments.refund"),
    ],
    settings: [
      t("dashboard", "organizationAssistant.chips.settings.inviteMember"),
      t("dashboard", "organizationAssistant.chips.settings.paymentNotifications"),
      t("dashboard", "organizationAssistant.chips.settings.legalName"),
    ],
    serviceEntry: [
      t("dashboard", "formNew.serviceEntryB.assistant.chips.merch"),
      t("dashboard", "formNew.serviceEntryB.assistant.chips.combined"),
      t("dashboard", "formNew.serviceEntryB.assistant.chips.membership"),
    ],
    default: [
      t("dashboard", "organizationAssistant.chips.bank.lastPayout"),
      t("dashboard", "organizationAssistant.chips.forms.soldOut"),
      t("dashboard", "organizationAssistant.chips.settings.inviteMember"),
    ],
  };
  return chips[getStarterChipGroup(pathWithoutLocale)];
};
